import {Component} from 'react';
import PropTypes from 'prop-types';
import {find, size, trim, uniqBy} from 'lodash';
import {Input, Search} from 'semantic-ui-react';
import {PropertySuggestionsApi} from '../api/PropertySuggestionsApi';

export default class AddComparable extends Component {

  static propTypes = {
    onSelect: PropTypes.func,
    disabled: PropTypes.bool,
  };

  state = {
    matchingComparableProperties: [],
    value: '',
  };

  onSearchChange = (e, searchAddress) => {
    this.setState({
      value: searchAddress.value,
    });

    const trimmedAddress = trim(searchAddress.value);
    if (size(trimmedAddress) > 3) {
      PropertySuggestionsApi.request(trimmedAddress, (comparableProperties) => {
        this.setState({
          matchingComparableProperties: comparableProperties,
        });
      });
    } else {
      this.setState({
        matchingComparableProperties: [],
      });
    }
  };

  onResultSelect = (e, data) => {
    if (this.props.onSelect) {
      const {matchingComparableProperties} = this.state;
      const selectedProperty = find(matchingComparableProperties, (p) => p.singleLineAddress === data.result.title);
      this.props.onSelect(selectedProperty);

      this.setState({
        value: '',
      });
    }
  };

  render() {
    const {disabled} = this.props;
    const {matchingComparableProperties, value} = this.state;
    const results =
      uniqBy(matchingComparableProperties, 'singleLineAddress')
        .map((property) => ({title: property.singleLineAddress}));

    return (
      <Search
        fluid
        placeholder="Enter Address"
        onSearchChange={this.onSearchChange}
        onResultSelect={this.onResultSelect}
        value={value}
        results={results}
        input={
          <Input fluid
                 disabled={disabled}
                 input={{className: ''}} // remove "prompt" className that Semantic-UI adds for very rounded appearance
                 icon={false}
          />}
      />
    );
  }
}